import "./App.css";
import HomeHero from "./components/HomeHero";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import OurMission from "./components/OurMission";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
import OurStats from "./components/OurStats";
import Header from "./components/Header";
import ContactForm from "./components/ContactForm";
import OurLeadership from "./components/OurLeadership";
import OurPhilosophy from "./components/OurPhilosophy";
import Pricing from "./components/Pricing";
import OurProcess from "./components/OurProcess";
import Portfolio from "./components/Portfolio";
import FAQSection from "./components/FAQSection";

function App() {
  return (
    <>
      <Header />
      <HomeHero />
      <AboutUs />

      <OurMission />
      <ProblemSection />
      <SolutionSection />
      <OurStats />
      <OurProcess />
      <hr />
      <Pricing />
      <hr />
      <FAQSection />
      <hr />
      <Portfolio />
      {/* <ContactForm /> */}

      <section
        id="action-box2"
        className="action-box action-black"
        style={{
          backgroundImage:
            "linear-gradient(135deg, #1a2230 0%, #111826 55%, #0d121b 100%)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          position: "relative",
          color: "#fff",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
          }}
        ></div>

        <div
          className="container cta-contact-wrap"
          style={{ position: "relative", zIndex: 2 }}
        >
          <div className="row action-box-left cta-contact-content">
            <h3 className="action-box-title">
              Stop managing orders on WhatsApp & Start running a proper online
              store.
            </h3>
            <br />

            <p
              className="action-box-subtitle"
              style={{ maxWidth: "600px", margin: "0 auto" }}
            >
              Tell us about your business and we’ll guide you on the best setup.
              Simple, quick, and made for small business owners.
            </p>
            <br />

            <p style={{ marginTop: "10px", fontSize: "14px", color: "#fff" }}>
              ✔ Free consultation &nbsp; | &nbsp; ✔ No pressure &nbsp; | &nbsp;
              ✔ Quick response
            </p>
          </div>

          <div className="cta-contact-actions" style={{ marginTop: "20px" }}>
            <a
              className="btn btn-lg btn-color"
              href="https://wa.me/919958920231?text=Hi%2C%20I%20want%20to%20set%20up%20my%20Shopify%20store"
              target="_blank"
              rel="noopener noreferrer"
            >
              Chat on WhatsApp →
            </a>
            <br />
            <br />

            <p className="cta-contact-note" style={{ marginTop: "10px" }}>
              Takes less than 2 minutes to get started
            </p>

            <p style={{ fontSize: "13px", color: "white" }}>
              ⚠️ Limited slots this month
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default App;
